import type { FC } from 'react'
import styled from 'styled-components'

const StyledContainer = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 5px;
  color: ${({ disabled }) => (disabled ? '#A0A0A0' : '#000')};
`

interface Props {
  checked: boolean
  disabled?: boolean
  onChange: React.InputHTMLAttributes<HTMLInputElement>['onChange']
  label: string
  testId?: string
}

const Checkbox: FC<Props> = ({ checked, onChange, label, disabled, testId }) => (
  <StyledContainer disabled={disabled}>
    <input
      data-testid={testId}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    />
    {label}
  </StyledContainer>
)

export default Checkbox
